<template>
  <v-app>
    <employee-weekend-form
      :dialog="dialog"
      :data="formData"
      @update:dialog="dialog = $event"
    />
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Employee Wise Weekend
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col lg="3" md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col lg="5" md="4" cols="12">
                    <div class="d-flex align-center justify-center pr-2">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col lg="4" md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="openCreateDialog"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Employee Weekend
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="employeeWeekendList"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1 || item.status === '1'"
                      color="success"
                      size="small"
                      class="text-capitalize"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                    >
                      Inactive
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    >
                      mdi mdi-pencil-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import employeeWeekendForm from "@/components/module/attendance/settingsManagement/employeeWeekendForm.vue";

export default {
  components: {
    employeeWeekendForm,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    formData: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Employee Code", key: "employeeCode", align: "left", sortable: false },
      { title: "Employee Name", key: "employeeName", align: "left", sortable: false },
      { title: "Weekend Days", key: "daysLabel", align: "left", sortable: false },
      { title: "Start Date", key: "start_date", align: "center", sortable: false },
      { title: "End Date", key: "end_date", align: "center", sortable: false },
      { title: "Remarks", key: "remarks", align: "left", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: false },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  created() {
    if (this.$store.getters.getEmployeeWeekendList.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("getEmployeeWeekendList")
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    employeeWeekendList() {
      const list = this.$store.getters.getEmployeeWeekendList || [];
      return list.map((item) => {
        const days = Array.isArray(item.day_names)
          ? item.day_names
          : Array.isArray(item.days)
          ? item.days.map((day) => day?.day?.name || day?.name)
          : [];
        return {
          ...item,
          employeeCode:
            item.employee?.employee_code || item.employee_code || "-",
          employeeName:
            item.employee?.employee_name || item.employee_name || "-",
          daysLabel: this.formatItemsForLabel(days),
          start_date: item.start_date || "-",
          end_date: item.end_date || "-",
          remarks: item.remarks || "-",
        };
      });
    },
  },
  methods: {
    openCreateDialog() {
      this.formData = {
        weekend_employee_id: "",
        employee_id: "",
        day_ids: [],
        start_date: "",
        end_date: "",
        remarks: "",
        status: "1",
      };
      this.dialog = true;
    },
    editItem(item) {
      const dayIds = Array.isArray(item.day_ids)
        ? item.day_ids
        : (item.days || []).map((day) => day?.day_id || day?.id).filter(Boolean);
      this.formData = {
        weekend_employee_id: item.weekend_employee_id || item.id || "",
        employee_id: item.employee_id || "",
        day_ids: dayIds,
        start_date: item.start_date || "",
        end_date: item.end_date || "",
        remarks: item.remarks || "",
        status: item.status ?? "1",
      };
      this.dialog = true;
    },
    formatItemsForLabel(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return "-";
      }
      return items
        .map((entry) => {
          if (typeof entry === "string") {
            return entry;
          }
          if (typeof entry === "object" && entry !== null) {
            return entry.label || entry.name;
          }
          return entry;
        })
        .filter(Boolean)
        .join(", ");
    },
    exportColumns() {
      return [
        "#SL",
        "Employee Code",
        "Employee Name",
        "Weekend Days",
        "Start Date",
        "End Date",
        "Remarks",
        "Status",
      ];
    },
    exportRows() {
      let serialNumber = 1;
      return this.employeeWeekendList.map((item) => [
        serialNumber++,
        item.employeeCode,
        item.employeeName,
        item.daysLabel,
        item.start_date || "-",
        item.end_date || "-",
        item.remarks || "-",
        item.status == 1 || item.status === "1" ? "Active" : "Inactive",
      ]);
    },
    exportToPDF() {
      this.$exportTableToPDF(
        this.exportColumns(),
        this.exportRows(),
        "Employee Weekend List",
        "employee_weekend_list_" + this.$fileDate()
      );
    },
    exportToExcel() {
      const data = [this.exportColumns(), ...this.exportRows()];
      this.$exportTableToExcel(
        data,
        "employee_weekend_list_" + this.$fileDate()
      );
    },
    exportToCSV() {
      const data = [this.exportColumns(), ...this.exportRows()];
      this.$exportTableToCSV(
        data,
        "employee_weekend_list_" + this.$fileDate()
      );
    },
  },
};
</script>

